import { useClientTranslation } from '@/lib/core/i18n';
import { useAuthStore } from '@/lib/core/stores';
import { getFirstName } from '@/lib/core/utils/user';

interface AssistanceBlockProps {
  className?: string;
}

export function AssistanceBlock({ className }: AssistanceBlockProps) {
  const t = useClientTranslation();
  const user = useAuthStore(s => s.user);
  const firstName = getFirstName(user?.name);
  const hasActiveMembership = user?.hasActiveMembership;

  const assistanceSubtitle = t('App.Explore.Map.AssistanceSubtitle', {
    concierge: hasActiveMembership
      ? t('App.Labels.AssistanceConciergeLabel')
      : t('App.Labels.AssistanceCustomerServiceLabel'),
  });

  return (
    <div className={`flex flex-col gap-4 pt-2 ${className ?? ''}`}>
      <p className="font-pp-neue-montreal text-jncquoi-neutral-1000 text-[14px] leading-none tracking-[0.5px]">
        <span>{t('App.Explore.Map.NeedAssistance')}</span> <span className="font-semibold">{firstName}?</span>
      </p>
      <p className="font-pp-neue-montreal text-jncquoi-neutral-800 text-[12px] leading-normal tracking-[0.5px]">
        {assistanceSubtitle}
      </p>
    </div>
  );
}
